/**
 * Purpose:
 *   Renders loading spinner overlay for button.
 */

import { Spinner } from '../spinner/Spinner';
import { buttonStyles } from './Button.styles';
import type { TButtonSize } from './Button.types';

export interface IButtonSpinnerProps {
  loading: boolean;
  size?: TButtonSize;
}

export function ButtonSpinner({ loading, size = 'md' }: IButtonSpinnerProps) {
  if (!loading) return null;

  const iconSize = size === 'sm' ? 16 : 18;

  return (
    <span aria-hidden="true" className={buttonStyles.spinnerContainer}>
      <Spinner size={iconSize} thickness={4} />
    </span>
  );
}
